export default __webpack_public_path__ + "static/media/apple-wallet-icon.ede6eb38.png";